__turbopack_context__.v({
  "not-clickable": "RoundCheckBox-module-scss-module__cq-2Xq__not-clickable",
  "pickup-method-radio": "RoundCheckBox-module-scss-module__cq-2Xq__pickup-method-radio",
  "pickup-method-radio-inner": "RoundCheckBox-module-scss-module__cq-2Xq__pickup-method-radio-inner",
  "selected": "RoundCheckBox-module-scss-module__cq-2Xq__selected",
  "wrapper": "RoundCheckBox-module-scss-module__cq-2Xq__wrapper",
});
